export default __webpack_public_path__ + "static/media/logo.d011cc47.png";